const Footer = () => {
  return (
        <div style={{ backgroundColor: '#1a1a1a' }}>
            <footer className="text-center text-sm text-white py-4">
                © {new Date().getFullYear()} Developed by Arvind Boominathan
            </footer>
            </div>
  )
}

export default Footer;